<template>
  <div
    ref="container"
    class="split-container"
  >
    <div
      ref="top"
      class="split-container__top"
    >
      <div class="split-container__inner split-container__inner--top">
        <slot name="top" />
      </div>
    </div>

    <div
      class="split-container__resizer"
      @mousedown.left="onMouseDown"
    />

    <div
      ref="bottom"
      class="split-container__bottom"
    >
      <div class="split-container__inner">
        <slot name="bottom" />
      </div>
    </div>
  </div>
</template>

<script>
import util from 'Modules/util'

const SPLIT_SIZE_KEY = 'gridSplit'
const RESIZER_HEIGHT = 20

export default {
  data() {
    return {
      container: null,
      top: null,
      mousePos: null,
      maxHeight: null
    }
  },
  mounted() {
    this.container = this.$refs.container
    this.top = this.$refs.top

    document.addEventListener('mouseup', this.onMouseUp, false)
    window.addEventListener('resize', this.setMaxHeight, false)

    this.setMaxHeight()
    this.setDefaultHeight()
  }, beforeUnmount() {
    document.body.removeEventListener('mouseup', this.onMouseUp)
    window.removeEventListener('resize', this.setMaxHeight)
  },
  methods: {
    onMouseDown(e) {
      e.preventDefault() // prevent text selection

      this.mousePos = e.y
      document.addEventListener('mousemove', this.resize, false)
    },
    onMouseUp() {
      document.removeEventListener('mousemove', this.resize, false)
    },
    resize(e) {
      const diff = e.y - this.mousePos
      const height = parseInt(getComputedStyle(this.top, '').height) + diff

      this.mousePos = e.y
      if (height >= 0 && height <= this.maxHeight) {
        this.setTopPanelHeight(height)
        localStorage.setItem(SPLIT_SIZE_KEY, JSON.stringify({
          top: height
        }))
      }
    },
    setDefaultHeight() {
      let height

      const parsed = localStorage ? util.JSONParse(localStorage.getItem(SPLIT_SIZE_KEY)) : null

      if (parsed && parsed.top) {
        height = parsed.top
      } else {
        height = this.container.clientHeight / 2 - RESIZER_HEIGHT / 2
      }

      this.setTopPanelHeight(height)
    },
    setTopPanelHeight(height) {
      this.top.style.height = `${height}px`
    },
    setMaxHeight() {
      this.maxHeight = this.container.clientHeight - RESIZER_HEIGHT

      if (this.top.clientHeight > this.maxHeight) { // make sure our top container is not taller than container
        this.setTopPanelHeight(this.maxHeight)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

$resizerHeight: 20px;
$resizerIconWidth: 40px;
$resizerIconHeight: 12px;

.split-container {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - #{$headerHeight});
  max-height: 100%;
  overflow: hidden;

  &__top {
    position: relative;
    flex-shrink: 0;
    overflow: hidden;
  }

  &__bottom {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
  }

  &__inner {
    width: 100%;
    max-height: 100%;
    overflow-x: auto;

    &--top {
      height: 100%;
    }
  }

  &__resizer {
    position: relative;
    flex-shrink: 0;
    height: $resizerHeight;
    background-color: #e5e5e5;
    cursor: row-resize;

    &::before {
      position: absolute;
      top: ($resizerHeight - $resizerIconHeight) * 0.5;
      left: 50%;
      display: block;
      width: $resizerIconWidth;
      height: $resizerIconHeight;
      margin-left: - ($resizerIconWidth * 0.5);
      background-image: $dragHandleImage;
      content: '';
    }
  }
}
</style>
